import { FC, ReactNode, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { OnePlusNRollingOffer } from '@appcharge/shared-ui';
import useOffersUI from 'api/useOffersUI';
import { Offer, RollingOfferProductSequence } from 'common/contracts';
import { OfferPreviewShell } from 'views/Offers/components/OfferPreviewShell';

import {
  BUY_ONE_GET_MANY_CONTAINER_STYLE,
  BUY_ONE_GET_MANY_PREVIEW_INDEX_TO_COLLECT
} from './BuyOneGetManyPreview.consts';
import {
  mapProductsSequence,
  reindexForBuyOneGetMany,
  resolveBuyOneGetManyDesignProps,
  truncateForBuyOneGetMany
} from './BuyOneGetManyPreview.utils';

interface BuyOneGetManyPreviewProps {
  currentOfferUI: string;
  productsSequence: RollingOfferProductSequence[];
  progressBarOffers?: Offer[];
  freeTilesCount?: number;
}

export const BuyOneGetManyPreview: FC<BuyOneGetManyPreviewProps> = ({
  currentOfferUI,
  productsSequence,
  progressBarOffers = [],
  freeTilesCount
}) => {
  const { publisherId } = useParams();
  const { getOfferUI } = useOffersUI(publisherId, currentOfferUI);

  const offerUIData = getOfferUI?.data;

  const subRollingOffersProducts = useMemo(
    () =>
      productsSequence
        ? mapProductsSequence(productsSequence, progressBarOffers)
        : [],
    [productsSequence, progressBarOffers]
  );

  const previewProducts = useMemo(
    () =>
      reindexForBuyOneGetMany(
        truncateForBuyOneGetMany(subRollingOffersProducts, freeTilesCount)
      ),
    [subRollingOffersProducts, freeTilesCount]
  );

  const designProps = useMemo(
    () => resolveBuyOneGetManyDesignProps(offerUIData),
    [offerUIData]
  );

  return (
    <OfferPreviewShell containerStyle={BUY_ONE_GET_MANY_CONTAINER_STYLE}>
      {({ storeScreen }): ReactNode => (
        <OnePlusNRollingOffer
          offerId="buy-one-get-many-preview"
          isPreview
          isPermanent
          indexToCollect={BUY_ONE_GET_MANY_PREVIEW_INDEX_TO_COLLECT}
          backgroundImage={designProps.backgroundImage}
          headerImage={designProps.headerImage}
          backgroundOpacity={designProps.backgroundOpacity}
          backgroundColor={designProps.backgroundColor}
          borderColor={designProps.borderColor}
          borderWidth={designProps.borderWidth}
          collectBehavior="disappear"
          subRollingOfferUiProps={{
            backgroundColor: designProps.subBackgroundColor,
            backgroundImage: designProps.subBackgroundImage,
            lockImage: designProps.lockImage,
            buttonColor: storeScreen.buttonColor,
            collectText: designProps.collectText,
            buttonTextColor: storeScreen.buttonTextColor
          }}
          selectOffer={() => undefined}
          subRollingOffersProducts={previewProducts}
          variantConfig={{
            kind: 'onePlusN',
            plusImage: designProps.plusImage,
            freeTilesColumns: designProps.freeTilesColumns
          }}
        />
      )}
    </OfferPreviewShell>
  );
};
